import { Images } from '@/assets/images';
import { DocTypeEnum, REGEX } from '@/constant';
import { cn } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	ministryOfJusticeNumber: '',
	numberOfTime: '',
	applicantName: '',
	applicantBirthDate: '',
	applicantAddress: '',
	applicantPhone: '',
	height: '',
	weight: '',
	bloodPressure: '',
	leftEye: '',
	rightEye: '',
	colorBlindness: '',
	leftEar: '',
	rightEar: '',
	philopon: '',
	cocain: '',
	opium: '',
	hemp: '',
	etc: '',
	testDate: '',
	doctorSignature: '',
	result: '',
	reason: '',
	opinion: '',
	checkDetails: '',
	registerDate: '',
	headOfAgencySignature: '',
	avatar: '',
};

type IValues = typeof initializeValue;

export const MINISTRY_OF_JUSTICE_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.AFR_04
> = {
	initializeValue,
	title: '마약검사 확인서(법무부 지정 의료기관)',
	mapPropToValues({
		refTableName,
		applicantData,
		lodgingData,
		applicantLodgingData,
	}) {
		return {
			...initializeValue,
			applicantName: applicantData?.fullName || '',
			applicantBirthDate: applicantData?.birthDate || '',
			applicantPhone: applicantData?.phone || '',
			avatar: applicantData?.avatarFile || '',
			applicantAddress: lodgingData?.address
				? lodgingData?.address
				: applicantLodgingData?.lodgingAddress || '',
		};
	},
	pages: [
		{
			background: {
				src: Images.formMinistryOfJusticeHighlight,
				className: 'template',
				dataSource: Images.formMinistryOfJustice,
			},

			textAreas: [
				{
					name: 'ministryOfJusticeNumber',
					maxHeight: 20,
					maxLength: 50,
					containerClassName: 'absolute top-[119px] left-[415px] w-[290px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'numberOfTime',
					maxHeight: 20,
					maxLength: 7,
					containerClassName: 'absolute top-[234px] left-[102px] w-[85px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'applicantName',
					maxHeight: 41,
					maxLength: 50,
					containerClassName: 'absolute top-[262px] left-[189px] w-[140px]',
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'applicantAddress',
					maxHeight: 60,
					maxLength: 45,
					containerClassName: 'absolute top-[307px] left-[187px] w-[145px]',
				},
				{
					name: 'applicantPhone',
					maxHeight: 60,
					maxLength: 18,
					containerClassName: 'absolute top-[307px] left-[460px] w-[145px]',
					regex: REGEX.ALLOW_PHONE_NUMBER,
				},
				{
					name: 'height',
					maxHeight: 18,
					maxLength: 9,
					containerClassName: 'absolute top-[439px] left-[178px] w-[70px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					className: 'text-right',
				},
				{
					name: 'weight',
					maxHeight: 18,
					maxLength: 6,
					containerClassName: 'absolute top-[439px] left-[378px] w-[50px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					className: 'text-right',
				},
				{
					name: 'bloodPressure',
					maxHeight: 20,
					maxLength: 16,
					containerClassName: 'absolute top-[440px] left-[568px] w-[120px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'leftEye',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[470px] left-[228px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'rightEye',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[496px] left-[228px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'colorBlindness',
					maxHeight: 45,
					maxLength: 20,
					containerClassName: 'absolute top-[468px] left-[378px] w-[79px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'leftEar',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[470px] left-[640px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'rightEar',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[496px] left-[640px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'philopon',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[554px] left-[144px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'cocain',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[554px] left-[271px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'opium',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[554px] left-[384px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'hemp',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[554px] left-[501px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'etc',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[554px] left-[616px] w-[70px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				(values, index) => ({
					name: 'doctorSignature',
					maxHeight: 20,
					maxLength: 12,
					containerClassName: 'absolute top-[654px] left-[535px] w-[114px]',
				}),
				(values, index) => ({
					name: 'reason',
					maxHeight: 20,
					maxLength: 36,
					containerClassName: cn('absolute top-[720px] left-[346px] w-[360px]'),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					onKeyDown: (e) => {
						if (e.key === 'Tab' || e.key === 'Enter') {
							e.preventDefault();
						}
					},
					disabled: values?.result !== '불량',
				}),
				{
					name: 'opinion',
					maxHeight: 40,
					maxLength: 90,
					containerClassName: 'absolute top-[748px] left-[210px] w-[500px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
				},
				(values, index) => ({
					name: 'checkDetails',
					maxHeight: 40,
					maxLength: 90,
					className: 'text-[14px] text-left focus:bg-white !h-[40px]',
					containerClassName: cn(
						'absolute top-[803px] left-[210px] w-[500px]',
						values?.checkDetails && 'bg-white'
					),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					onKeyDown: (e) => {
						if (e.key === 'Tab' || e.key === 'Enter') {
							e.preventDefault();
						}
					},
				}),
				{
					name: 'headOfAgencySignature',
					maxHeight: 20,
					maxLength: 12,
					containerClassName: 'absolute bottom-[162px] right-[148px] w-[127px]',
				},
			],
			checkboxes: [
				{
					name: 'result',
					classNames: [
						'absolute top-[695px] left-[271px] w-[12px] h-[12px]',
						'absolute top-[695px] right-[404px] w-[12px] h-[12px]',
					],
					options: ['양호', '불량'],
					getResetKey: () => ['reason'],
					iconType: 'square',
				},
			],
			datePickers: [
				{
					name: 'applicantBirthDate',
					className: '[&>.ant-picker-input>input]:!text-[14px]',
					containerClassName: 'absolute top-[270px] left-[460px] w-[120px]',
					format: 'YYYY-MM-DD',
				},
				{
					name: 'testDate',
					segmentedInputs: true,
					containerClassName: 'absolute top-[625px] left-[516px] w-[170px]',
					format: 'YYYY          MM           DD',
					style: { fontSize: '14px' },
					boxStyle: { marginBottom: '-17px' },
				},
				{
					name: 'registerDate',
					segmentedInputs: true,
					containerClassName: 'absolute top-[887px] left-[516px] w-[170px]',
					format: 'YYYY          MM           DD',
					style: { fontSize: '14px' },
					boxStyle: { marginBottom: '-17px' },
				},
			],
			inputFiles: [
				{
					name: 'avatar',
					className: 'absolute top-[210px] left-[583px] w-[128px] h-[159px]',
					classNameIconDelete: 'w-6 h-6',
				},
			],
		},
	],
};
